import React, { useState } from 'react';
import useNewCareerPositionContext from 'contexts/career-position.context';
import { Textarea, ToastMessage } from '@cokitchen/cokitchen-components';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import SingleBottomNav from 'components/base/single-bottom-nav';
import { useParams } from 'react-router-dom';
import { parseBulletPoints } from 'pages/create-career-position/create-job-details/utils';

type Props = {
  onEditComplete: () => void;
};
const EditJobDescription = ({ onEditComplete }: Props) => {
  const { createJobPositionForm, setCreateJobPositionForm } = useNewCareerPositionContext();
  const [loading, setLoading] = useState(false);
  const { job_id } = useParams();

  const handleUpdateJobPosting = async () => {
    setLoading(true);

    try {
      await apiService.put(`careers/jobs/${job_id}`, {
        data: {
          description: createJobPositionForm.roleSummary,
          responsibilities: parseBulletPoints(createJobPositionForm.responsibilities),
          qualifications: parseBulletPoints(createJobPositionForm.qualifications),
          status: createJobPositionForm.status
        }
      });

      onEditComplete();
      toast(<ToastMessage type='success' message={`Job updated successfully`} />);
    } catch {
      toast(<ToastMessage type='error' message={`There was a problem creating position `} />);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className='space-y-4'>
      <Textarea
        className='w-full mt-1'
        label='Role summary'
        value={createJobPositionForm.roleSummary}
        onChange={(e) =>
          setCreateJobPositionForm({ ...createJobPositionForm, roleSummary: e.target.value })
        }
        placeholder='Enter job role summary'
      />
      <Textarea
        className='w-full mt-1'
        label='Responsibilies'
        value={createJobPositionForm.responsibilities}
        onChange={(e) =>
          setCreateJobPositionForm({ ...createJobPositionForm, responsibilities: e.target.value })
        }
        placeholder='Enter responsibilies (bullet points i.e "-")'
      />
      <Textarea
        className='w-full mt-1'
        label='Qualifications'
        value={createJobPositionForm.qualifications}
        onChange={(e) =>
          setCreateJobPositionForm({ ...createJobPositionForm, qualifications: e.target.value })
        }
        placeholder='Enter qualifications (bullet points i.e "-")'
      />

      <SingleBottomNav
        loading={loading}
        onConfirm={handleUpdateJobPosting}
        backBtndisabled
        btnDisabled={loading}
      />
    </div>
  );
};

export default EditJobDescription;
